import styled from 'styled-components';

export const SurveyForm = styled.div<{ gap?: number; padding?: string }>`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  gap: ${(props) => (props.gap !== undefined ? `${props.gap}px` : '16px')};

  overflow-y: scroll;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }

  padding: ${(props) => (props.padding ? `${props.padding}` : '4px')};
`;
